import { render, staticRenderFns } from "./Lgx296721465565249536.vue?vue&type=template&id=00790996&"
import script from "./Lgx296721465565249536.vue?vue&type=script&lang=js&"
export * from "./Lgx296721465565249536.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports